import { render, staticRenderFns } from "./expenses.component.vue?vue&type=template&id=f444d062&"
import script from "./expenses.component.vue?vue&type=script&lang=js&"
export * from "./expenses.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports